<template>
    <div class="modal fade" id="addCalendarEvents" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title text" style="color: #6b819b;" id="exampleModalLongTitle">
              Crear Evento de Agenda
            </h6>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">                
                  <TiendaSelectComponent 
                    :disabled="false" 
                    :current="current" 
                    :myprofile="true"
                    :placeholder="`- Seleccione Tienda -`"
                  />              
              </div>
              <div class="col-md-12">
                <ProveedoresSelectComponent :current="current" />
              </div>
              <div class="col-6">
                <label>Tipo Evento:</label>
                <select v-model="current.tipo" class="form-control">
                  <option value="R" selected>Recepción</option>
                  <option value="C">Cita</option>
                </select>
              </div>
              <div class="col-6">
                <label>
                  {{ current.tipo == "R" ? "Fecha de Recepción:" : "Fecha de Visita:" }}
                 </label>
                <br />
                <input 
                  v-model="date_select_patter" 
                  type="date"
                  class="form-control-sm form-control py-1" 
                />
              </div>
              <div class="col-6">
                <label>Hora Inicia</label>
                <input v-model="current.hour_start" class="form-control" type="time" id="time-select" name="time"
                  min="05:00" max="20:00" />
                <small v-if="current.errors && current.errors.fecha_de">{{
                  current.errors.fecha_de
                  }}</small>
              </div>
              <div class="col-6">
                <label>Hora fin</label>
                <input v-model="current.hour_end" class="form-control" type="time" id="time-select" name="time"
                  min="05:00" max="20:00" />
                <small v-if="current.errors && current.errors.fecha_de">{{
                  current.errors.fecha_a
                  }}</small>
              </div>
              <div class="col-12">
                <label>Observaciones:</label>
                <textarea v-model="current.observaciones" class="form-control" type="text">
                </textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="agendarProveedor()" class="btn btn-dark">
              Crear <i class="fas fa-check"></i>
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="CancelRec()">
              Cancelar <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import AgendaProveedoresService from "@/services/wms/AgendaProveedoresService";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";

export default {
  inject: {
    refreshAgenda: {
      from: 'refreshAgenda',
      default: () => {}
    },
  },
  props: {
    date_select_patter: {
      type: String
    },
  },
  components: {
    ProveedoresSelectComponent,
    TiendaSelectComponent,
    LoaderComponent,
  },
  watch: {
    refreshAllData(newValue) {
      console.log("newValue", newValue);
      this.refreshAgenda();
      this.refreshAgendaChild();
    }
  },
  mounted() {
    this.current.date_select = this.date_select_patter;
  },
  data() {
    return {
      current: {
        date_select: "",
        current_day: "",
        fecha_actual: "",
        tienda: "",
        tipo: "R",
        errors: [],
      },
      detalle: "",
      eventoSeleccionadoEliminarAPN: null,
      eventos_actuales: [],
      tipoEvento: {
        R: "RECEPCIÓN",
        C: "CITA"
      },
      orderCompraNumber: "",
      ordenesCompra: [],
      isSearchAttempted: false,
      eventoSeleccionado: null,
      agendaCargada: false,
    };
  },
  methods: {
    agendarProveedor() {
      let self = this;
      if(self.current.tienda==""){
        Notifications.alert.error("Asignar tienda","Debe seleccionar una tienda" )           
        return;
      }
      if (!this.current.hour_start) {
        Notifications.alert.error("Horario","Debe seleccionar un horario inicial")
       self.current.errors.hour_start = "Este campo es requerido";
        return;
      }
      if (!this.current.hour_end) {
        Notifications.alert.error("Horario","Debe seleccionar un horario final")
        self.current.errors.hour_end = "Este campo es requerido";
        return;
      }        
      let fecha_inicio = this.date_select_patter + this.current.hour_start;
      let fecha_fin = this.date_select_patter + this.current.hour_end;
      self.current.fecha_de = moment(fecha_inicio, "YYYY-MM-DD HH:mm");
      self.current.fecha_a = moment(fecha_fin, "YYYY-MM-DD HH:mm");
      self.current.fecha_de = this.current.fecha_de.format("YYYY-MM-DD HH:mm");
      self.current.fecha_a = this.current.fecha_a.format("YYYY-MM-DD HH:mm");
      let params = self.current;  
      if (self.current.proveedor) {
        params.proveedor = self.current.proveedor.codigo;
      }else{
        Notifications.alert.error("Agendar proveedor", "Debe seleccionar un proveedor");
        return;
      }
    
     
      DynamicService.save("wms", "agenda-proveedores", params)
        .then((response) => {
          $("#addCalendarEvents").modal("hide");
          $("#menuCalendarOptions").modal("show");
          this.refreshAgenda();
          self.refreshData();
          Notifications.alert.success("Agendar proveedor", "Realizado correctamente");
        })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.alert.error("Agendar proveedor", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },
    refreshData() {
      let self = this;
      delete self.current.proveedor;
      self.current.observaciones = "";
      self.current.hour_start = "";
      self.current.hour_end = "";
      self.current.tipo = "R";
    },
    addNewEvents() {
      $("#menuCalendarOptions").modal("hide");
      $("#addCalendarEvents").modal("show");
    },

    OpenSlideOpt(det) {
      let self = this;
      if (self.detalle == det) {
        self.detalle = "";
        return;
      }
      self.detalle = det;
    },
    CancelRec() {
      let self = this;
      self.refreshData();
      $("#addCalendarEvents").modal("hide");
      $("#menuCalendarOptions").modal("show");
    },
  },
};
</script>
<style scoped>
input[type="date"] {
    appearance: none;
    background-color: #fff;
    border: 2px solid #dadada;
    width: 100%;
    border-radius: 5px;
    cursor: pointer;
    color: #333;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
}

.center {
  margin-left: 40px;
  margin-top: 10px;
}

.select-size {
  width: 345px;
  height: 24px;
}

.time-size {
  width: 115px;
  height: 24px;
}

.item {
  display: inline;
  width: 100%;
  height: 24px;
}

.invoice-table {
  max-height: 400px;
  overflow-y: auto;
}

.ordencompra-table {
  max-height: 170px;
  overflow-y: auto;
}

.anadidos-table {
  max-height: 193px;
  overflow-y: auto;
}

.badge {
  font-size: 11px;
  padding: 1px 11px;
  border-radius: 12px;
  text-transform: capitalize;
  height: 13px;
  width: 130px;
}
</style>
